import { render, staticRenderFns } from "./DetailAdv.vue?vue&type=template&id=48e6aa51&scoped=true&"
import script from "./DetailAdv.vue?vue&type=script&lang=js&"
export * from "./DetailAdv.vue?vue&type=script&lang=js&"
import style0 from "./DetailAdv.vue?vue&type=style&index=0&id=48e6aa51&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e6aa51",
  null
  
)

export default component.exports